import { useCurrentEnterpriseId, useCurrentUser } from '@mews-commander/core';
import { useRepositoryQuery, useRepositorySuspenseQuery } from '@mews-commander/data-access';
import { UpdateFormValuesInput } from './schema';

export const useAllAvailableEnterprisesQuery = (options = {}) => {
    return useRepositoryQuery('mewsBI', 'getAllAvailableEnterprises', {}, { gcTime: 0, ...options });
};

export const useAllAvailableUsersQuery = () => {
    return useRepositoryQuery('mewsBI', 'getAllAvailableUsers', {}, { gcTime: 0 });
};

export const useInitialValuesForCreate = (options = {}) => {
    const { data: enterpriseData, isLoading } = useAllAvailableEnterprisesQuery(options);
    const currentUser = useCurrentUser();
    const currentEnterpriseId = useCurrentEnterpriseId();
    const allEnterpriseIds = enterpriseData?.enterprises
        .filter(
            ({ id, isAlreadyUsed, isGoodDataOnboarded }) =>
                (!isAlreadyUsed && isGoodDataOnboarded) || id === currentEnterpriseId
        )
        .map((enterprise) => enterprise.id);

    return {
        data: {
            mewsBiWorkspaceId: '',
            enterpriseIds: allEnterpriseIds ?? [],
            userIds: [currentUser.id],
        },
        isLoading,
    };
};

export const useInitialValuesForEdit = (id: string): UpdateFormValuesInput => {
    const { data } = useRepositorySuspenseQuery('mewsBiIntegration', 'get', { id }, { gcTime: 0 });

    return {
        ...data,
        mewsBiWorkspaceId: data.mewsBiWorkspaceId ?? '',
        enterpriseIds: data.enterpriseIds ?? [],
        userIds: data.userIds ?? [],
        isEnabled: data.isEnabled ? ['true'] : [],
    };
};
